<template>
  <div class="layout">
    <dx-drawer
      class="drawer drawer-v2"
      position="before"
      template="menu"
      :opened.sync="menuOpened"
      :opened-state-mode="drawerOptions.menuMode"
      :reveal-mode="drawerOptions.menuRevealMode"
      :min-size="drawerOptions.minMenuSize"
      :shading="drawerOptions.shaderEnabled"
      :close-on-outside-click="drawerOptions.closeOnOutsideClick"
      :element-attr="{
        id: 'gc-base-layout-drawer',
        class: 'drawer gc-base-layout-drawer',
      }"
      :max-size="200"
    >
      <div class="container" id="container-wrapper">
        <gc-header-toolbar
          :menu-toggle-enabled="headerMenuTogglerEnabled"
          :toggle-menu-func="toggleMenu"
          :baseView="baseView"
          :selectedIndex="selectedIndex"
          :tabs="tabs"
          :isXSmall="isXSmall"
          :isLarge="isLarge"
          :back-button-enabled="backButtonEnable"
          :backButtonFunc="backButtonFunction"
          :ref="'headertoolbar'"
          v-if="applicationMode != 'GcorpRoam'"
        >
          <template v-slot:headerContent="slotProps">
            <slot name="headerContent" :baseView="slotProps.baseView" />
          </template>
        </gc-header-toolbar>

        <gc-roam-header-toolbar
          :menu-toggle-enabled="headerMenuTogglerEnabled"
          :toggle-menu-func="toggleMenu"
          :baseView="baseView"
          :selectedIndex="selectedIndex"
          :tabs="tabs"
          :isXSmall="isXSmall"
          :isLarge="isLarge"
          :back-button-enabled="backButtonEnable"
          :backButtonFunc="backButtonFunction"
          :ref="'headertoolbar'"
          v-if="applicationMode == 'GcorpRoam'"
          :headerConfig="headerConfig"
          :roamType="roamType"
        >
          <template v-slot:headerContent="slotProps">
            <slot name="headerContent" :baseView="slotProps.baseView" />
          </template>
        </gc-roam-header-toolbar>

        <dx-scroll-view ref="scrollViewRef" class="layout-body with-footer">
          <div class="content" :ref="'containerwrapper'">
            <slot />
            <DxLoadPanel
              v-if="formsConfig"
              :position="loadingPosition"
              :visible.sync="formsConfig.loadingVisible"
              :show-indicator="true"
              :show-pane="true"
              :shading="true"
              :hide-on-outside-click="false"
              shading-color="rgba(0,0,0,0)"
            />
            <GcPopupValidationSummary
              v-if="formsConfig"
              :showPopup.sync="formsConfig.validationSummaryVisible"
              :title="'Validation Errors'"
              :isXSmall="isXSmall"
              :items.sync="formsConfig.items"
              :onHidden="onHidden"
            ></GcPopupValidationSummary>
            <GcPopupValidationSummary
              v-if="formsConfig"
              :showPopup.sync="formsConfig.serverValidationSummaryVisible"
              :title="'Server Error'"
              :isXSmall="isXSmall"
              :items.sync="formsConfig.serverItems"
              :onHidden="onHidden"
            ></GcPopupValidationSummary>

            <GcPopupValidationSummary
              v-if="formsConfig"
              :showPopup.sync="formsConfig.validationWarningVisible"
              :title="
                formsConfig.warningTitle ? formsConfig.warningTitle : 'Warning'
              "
              :isXSmall="isXSmall"
              :items.sync="formsConfig.warningItems"
              :backButtonText="'OK'"
              :onHidden="onHidden"
            ></GcPopupValidationSummary>

            <GcPopupAlert
              v-if="formsConfig"
              :showPopupAlert.sync="formsConfig.popupAlertVisible"
              :title="''"
              :isXSmall="isXSmall"
              :message.sync="formsConfig.popupAlertMessage"
            ></GcPopupAlert>
          </div>
        </dx-scroll-view>
        <div class="gc-footer">
          <slot name="footer" />
        </div>
      </div>
      <!-- eslint-disable vue/no-unused-vars -->
      <gc-side-nav-menu
        slot="menu"
        slot-scope="_"
        class="dx-swatch-additional"
        :compact-mode="!menuOpened"
        :items="menuItems"
        @click="handleSideBarClick"
      >
        <!-- eslint-enable-->
        <dx-toolbar
          id="navigation-header"
          v-bind:class="[
            tabs.length != 0 && !isXSmall
              ? 'header-toolbar-with-tabs'
              : 'header-toolbar-no-tabs',
          ]"
        >
          <dx-item v-if="!isXSmall" location="before" css-class="menu-button">
            <!-- eslint-disable vue/no-unused-vars -->
            <dx-button
              icon="menu"
              styling-mode="text"
              @click="toggleMenu"
              slot-scope="_"
            />
            <!-- eslint-enable -->
          </dx-item>
          <dx-item location="before" css-class="header-title dx-toolbar-label">
            <!-- eslint-disable vue/no-unused-vars -->
            <div slot-scope="_">
              <!-- <div>{{ title }} AA</div> -->
              <img :src="imgUrl" style="width: 150px" />
            </div>
            <!-- eslint-enable -->
          </dx-item>
        </dx-toolbar>
      </gc-side-nav-menu>
    </dx-drawer>
  </div>
</template>

<script>
import GcHeaderToolbar from "@/components/gc-header-toolbar";
import GcSideNavMenu from "@/components/gc-side-nav-menu";
import { DxLoadPanel } from "devextreme-vue/load-panel";
// eslint-disable-next-line no-unused-vars
import { NavigationStorage } from "@/_services/storage";
import { mapGetters } from "vuex";

function removeIconProperty(obj) {
  for (let prop in obj) {
    if (prop === "icon") delete obj[prop];
    else if (typeof obj[prop] === "object") removeIconProperty(obj[prop]);
  }
}

export default {
  props: {
    title: String,
    isXSmall: Boolean,
    isLarge: Boolean,
    selectedIndex: Number,
    baseView: Object,
    backButtonEnable: Boolean,

    hasAutoComp: {
      type: Boolean,
      default: function () {
        return false;
      },
    },

    tabs: {
      type: Array,
      default: function () {
        return [];
      },
    },
    formsConfig: {
      type: Object,
      default: function () {
        return null;
      },
    },
    backButtonFunction: {
      type: Function,
      default: function () {
        return null;
      },
    },
    hotKeyExpand: {
      type: Function,
      default: function () {
        return null;
      },
    },
    sprocketRelativeId: {
      type: String,
      default: function () {
        return "#container-wrapper";
      },
    },
    headerMenuTogglerVisible: {
      type: Boolean,
      default: true,
    },
    headerConfig: {
      type: Object,
      default: () => {},
    },
    roamType: {
      type: String,
      default: "list",
    },
  },
  methods: {
    onHidden() {
      this.formsConfig.validationSummaryVisible = false;
      this.formsConfig.serverValidationSummaryVisible = false;
      this.formsConfig.validationWarningVisible = false;
    },
    toggleMenu(e) {
      const pointerEvent = e.event;
      pointerEvent.stopPropagation();
      if (this.menuOpened) {
        this.menuTemporaryOpened = false;
      }
      this.menuOpened = !this.menuOpened;
    },
    handleSideBarClick() {
      if (this.menuOpened === false) this.menuTemporaryOpened = true;
      this.menuOpened = true;
    },
    handleResize() {
      this.$store.dispatch(
        "ui/headerHeight",
        this.$refs["headertoolbar"].$el.clientHeight
      );
      this.$store.dispatch(
        "ui/viewHeight",
        this.$refs["scrollViewRef"].$el.clientHeight
      );

      setTimeout(() => {
        this.$store.dispatch("ui/checkGridNoData", true);
      }, 1000);
    },
  },
  data() {
    return {
      menuOpened: false,
      menuTemporaryOpened: false,
      menuItemsToFilter: [],
      loadingPosition: { of: this.sprocketRelativeId },
    };
  },
  created() {
    this.menuItemsToFilter = NavigationStorage.getItems();
    window.addEventListener("resize", this.handleResize);
    this.$logger.debug(this.baseView, "baseView");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  computed: {
    ...mapGetters({ getHotKeyCreateNew: "hotKey/getHotKeyCreateNew" }),
    imgUrl() {
      let baseUrl = process.env.VUE_APP_BASE_URL;
      if (baseUrl === "/") return `${baseUrl}statics/GCORP-CX.png`;
      else return `/${baseUrl}/statics/GCORP-CX.png`;
    },
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    drawerOptions() {
      const shaderEnabled = !this.isLarge;
      return {
        menuMode: this.isLarge ? "shrink" : "overlap",
        menuRevealMode: this.isXSmall ? "slide" : "expand",
        minMenuSize: this.isXSmall ? 0 : 40,
        menuOpened: this.isLarge,
        hideOnOutsideClick: !this.isLarge,
        shaderEnabled,
      };
    },
    headerMenuTogglerEnabled() {
      return !this.headerMenuTogglerVisible
        ? this.headerMenuTogglerVisible
        : this.isXSmall;
    },

    scrollView() {
      return this.$refs["scrollViewRef"].instance;
    },
    menuItems() {
      // eslint-disable-next-line no-console
      this.$logger.debug("isXSmall", this.isXSmall);

      if (this.isXSmall === true) {
        removeIconProperty(this.menuItemsToFilter);
      }
      return this.menuItemsToFilter;
    },
  },
  watch: {
    getHotKeyCreateNew(value) {
      if (value) {
        this.$store.dispatch("hotKey/setHotKeyCreateNew", false);

        if (this.baseView.mode != "review" && !this.baseView.id) return;

        var route = undefined;
        var key = `/${this.baseView.view}/create`;
        const id = this.baseView.id;
        this.$router.options.routes.forEach((element) => {
          if (element.path.match(new RegExp(key)) && route == undefined) {
            route = element;
          }
        });
        if (route) {
          // this.setIgnoreRouteChangeConfirmation();
          this.$router
            .push({
              path: route.path.replace("*", ""),
              query: {},
            })
            .then(() => {
              if (id) {
                location.reload();
              }
            });
        }
      }
    },
    isLarge() {
      if (!this.menuTemporaryOpened) {
        this.menuOpened = this.isLarge;
      }
    },
    isXSmall(value) {
      if (value)
        this.$store.dispatch("profile/setApplicationMode", "GcorpRoam");
      else this.$store.dispatch("profile/setApplicationMode", "Gcorp");
    },
    $route() {
      if (this.menuTemporaryOpened || !this.isLarge) {
        this.menuOpened = false;
        this.menuTemporaryOpened = false;
      }
      this.scrollView.scrollTo(0);
    },
    applicationMode(mode) {
      this.$logger.info(`Application Mode:  ${mode}`);
      this.menuItemsToFilter = NavigationStorage.getItems();
      // eslint-disable-next-line no-console
      this.$logger.debug(this.menuItemsToFilter);
    },
    menuOpened() {
      setTimeout(() => {
        this.$store.dispatch("ui/checkGridNoData", true);
      }, 1000);
    },
  },
  components: {
    GcHeaderToolbar,
    GcSideNavMenu,
    DxLoadPanel,
  },
  beforeMount() {
    let globalCss = document.querySelector("#global-css");
    globalCss.setAttribute("media", "not all");

    let salesCss = document.querySelector("#sales-css");
    salesCss.setAttribute("media", "not all");
  },
};
</script>

<style lang="scss">
.layout {
  width: 100%;
}

.container {
  height: 100%;
  flex-direction: column;
  display: flex;
}

.layout-body {
  flex: 1;
  min-height: 0;
  background-color: white;
}

.content {
  flex-grow: 1;
}

#navigation-header {
  @import "@/assets/styles/variables.additional.scss";
  background-color: $base-accent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .menu-button .dx-icon {
    color: $base-text-color;
  }

  .screen-x-small & {
    padding-left: 20px;
  }

  .dx-theme-generic & {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .header-title {
    img {
      width: 100px !important;
    }
  }
}

.toolbar-icon {
  width: 1em;
  height: 1em;
  -webkit-filter: grayscale(100%) brightness(500%) brightness(50%);
  filter: grayscale(100%) brightness(500%) brightness(50%);
}
.toolbar-label {
  margin-left: 10px;
  line-height: 30px;
}

.view-toolbar {
  padding-left: 10px;
  padding-right: 10px;
}

.view-card {
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  background-color: #fff;
  margin: 2px 0px 3px;
}

.dx-scrollview-content .content .view-card.responsive-paddings {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.dx-valid.dx-texteditor .dx-texteditor-input-container:after {
  display: none;
}

.dx-dialog .dx-popup-title,
.dx-popup-normal .dx-popup-title {
  background: #e8f7f9;
}

.dx-dialog
  .dx-popup-bottom
  .dx-toolbar-button
  .dx-button[aria-label="Yes"]
  .dx-button-content {
  color: #fff;
  background-color: #20a4da;
  border-color: #20a4da;
}

.dx-dialog
  .dx-popup-bottom
  .dx-toolbar-button
  .dx-button[aria-label="No"]
  .dx-button-content {
  color: #9a9ca5;
  background-color: #f3f3f3;
  border-color: #f3f3f3;
}

.layout-body .dx-scrollview-content .content .view-toolbar.dx-toolbar {
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.layout-body .dx-scrollview-content .content #userPanel {
  margin-top: 0;
}

.side-navigation-menu
  .menu-container
  .dx-scrollable-content
  ul
  li[aria-level="1"]:last-child {
  margin-bottom: 50px;
}

.app {
  background-color: white;
}

body {
  overscroll-behavior: contain;
  touch-action: manipulation !important;
}

.layout-body .dx-scrollable-content .dx-scrollview-content {
  height: 100%;
}

/**  margin helpers */
.ml-sm {
  margin-left: 10px;
}

.ml-xs {
  margin-left: 5px;
}

@import "@/assets/styles/gc-variables.scss";
</style>
